import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-traders-oem-header',
  templateUrl: './traders-oem-header.component.html',
  styleUrls: ['./traders-oem-header.component.css'],
})
export class TradersOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
